require('./bootstrap');

require('./components');
require('./datatables');
require('./pages');

require('./components/forms/BladeInput');
